import React from 'react';
import { injectIntl } from 'react-intl';

import UniverseLogo from '../../../assets/universe.svg';
import styles from './ErrorPage.css';
import locale from './locale';

export const ErrorPage = injectIntl(({ intl: { formatMessage }, header, message, navbar = false, error }) => {
  let headerText = formatMessage(locale.defaultHeader);
  if (header) headerText = header;

  let messageText = formatMessage(locale.defaultMessage);
  if (message) messageText = message;

  return (
    <React.Fragment>
      {navbar && (
        <div className={styles.blankNav}>
          <UniverseLogo />
        </div>
      )}
      <div className={styles.mainContainer}>
        <h1 className={styles.header}>{headerText}</h1>
        <p>{messageText}</p>
        {
          error && 
          <>
            <p>{error.message}</p>
            <pre>{error.stack}</pre>
          </>
        }
      </div>
    </React.Fragment>
  );
});
